import { render, staticRenderFns } from "./VerificationShield.vue?vue&type=template&id=82964f08&scoped=true"
import script from "./VerificationShield.vue?vue&type=script&lang=js"
export * from "./VerificationShield.vue?vue&type=script&lang=js"
import style0 from "./VerificationShield.vue?vue&type=style&index=0&id=82964f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82964f08",
  null
  
)

export default component.exports